import { Inject } from "@angular/core";
import { HopperOctopusConfiguration } from "../octopus/hopperOctopusConfiguration";

export type TransformOptionsType = { [key: string]: any };

export abstract class HopperApiClient {
  constructor(@Inject(HopperOctopusConfiguration) protected config: HopperOctopusConfiguration) {
  }

  protected getBaseUrl(baseUrl: string) : string {
    throw new Error("Method not implemented.");
  }

  protected async transformOptions(options: TransformOptionsType): Promise<TransformOptionsType> {
    throw new Error("Method not implemented.");
  }
}
